import { useCallback } from 'react';
import { TrayLabelInfo } from 'api/models/Deliveries';
import { useSaviAuthToken } from 'hooks/useSaviAuthToken';

export const useOpenSetLabelsPdf = () => {
  const { getFreshSaviAuthToken } = useSaviAuthToken();

  // fire-and-forget: navigates a new tab straight to the BE-rendered PDF rather than blocking
  // the UI on fetching a blob and opening it ourselves. The labels are serialised into the URL
  // (a plain GET has no body) because the just-checked-in tray isn't persisted yet, so the BE
  // can't look it up - the FE holds the label data locally and passes it straight through.
  const openSetLabelsPdf = useCallback(
    async (deliveryId: string, labels: TrayLabelInfo[]) => {
      const saviAuthToken = await getFreshSaviAuthToken();

      const params = new URLSearchParams();
      params.set('savi_auth_token', saviAuthToken);
      params.set(
        'labels',
        JSON.stringify(labels.map(({ setName, trayNumber, assetNumber }) => ({ setName, trayNumber, assetNumber }))),
      );

      const url = `${
        process.env.REACT_APP_SAVI_API_HOST
      }/api/v2/pdf/deliveries/${deliveryId}/set-labels/?${params.toString()}`;

      window.open(url, '_blank');
    },
    [getFreshSaviAuthToken],
  );

  return { openSetLabelsPdf };
};

export default useOpenSetLabelsPdf;
